import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { isInputField, isNestedFormField } from '../../types';
import { InputField } from './input-field';
import { ReadOnlyField } from './read-only-field';
import { NestedFormField } from './nested-form-field';
import { isMultilineAddressField } from '../../../../services/multiline-address';
export const FormField = _ref => {
  let {
    field,
    FieldLayout,
    ...rest
  } = _ref;
  if (!isMultilineAddressField(field) && isNestedFormField(field)) {
    return /*#__PURE__*/React.createElement(NestedFormField, _extends({}, rest, {
      field: field,
      FieldLayout: FieldLayout
    }));
  }
  if (isInputField(field)) {
    return /*#__PURE__*/React.createElement(InputField, _extends({}, rest, {
      field: field,
      FieldLayout: FieldLayout
    }));
  }
  return /*#__PURE__*/React.createElement(ReadOnlyField, _extends({}, rest, {
    field: field,
    FieldLayout: FieldLayout
  }));
};
//# sourceMappingURL=form-field.js.map